// src/components/MentionMenu.jsx
import React from "react";
import "./MentionMenu.css";

export default function MentionMenu({
  items,               // [{id, label, kind: 'user'|'group'|'team', payload}, ...]
  open,
  style,               // {top,left} absolute coords
  activeIndex,
  onHoverIndex,
  onPick
}) {
  if (!open) return null;
  return (
    <div className="mention-menu" style={style} role="listbox">
      {items.length === 0 ? (
        <div className="mention-menu-empty">No matches</div>
      ) : (
        items.map((it, i) => (
          <div
            key={it.id}
            role="option"
            aria-selected={i === activeIndex}
            style={it.group === "players" ? {color: 'var(--color-role-player)'} : undefined}
            className={`mention-menu-item ${i === activeIndex ? "active" : ""} ${it.kind} ${it.group || ""} ${
              it.group === "players" ? "role-player" : it.kind === "user" ? `role-${it.payload?.roleLower || "player"}` : ""
            }`}
            onMouseEnter={() => onHoverIndex(i)}
            onMouseDown={(e) => { e.preventDefault(); onPick(it); }}
          >
            {it.label}
          </div>
        ))
      )}
    </div>
  );
}
